// Base
const num = '[0-9]';
const alpha = '[a-zA-Z]';
const alphanum = '[a-zA-Z0-9]';
const alphanumext = '[a-zA-Z0-9._-]';
const encodeUrl = '[%]';
const exceptWhiteSpace = '\\S';
const allExcept = '[^/?\\s]';

// Root
const urlBlock = `${alphanum}+(-${alphanum}+)*`;
const urlBlocks = `${urlBlock}(\\.${urlBlock})*`;
const ext = `${alpha}{1,5}`;
const port = `${num}{1,5}`;

// Resource
const resourceBlock = `/${allExcept}*`;
const resourceBlocks = `(${resourceBlock})*/?(#${allExcept}+)?`;

// Base URL
const baseUrl = `${urlBlocks}\\.${ext}`;

// Ip Address
const ipBlock = '([0-9]{1,2}|[01][0-9]{2}|2[0-4][0-9]|25[0-5])';
const ip = `${ipBlock}(\\.${ipBlock}){3}`;

// Query params
const queryParamsPair = `${alphanumext}+(\\[${num}+\\])?=${exceptWhiteSpace}*`;
const queryParamsDLPair = `${exceptWhiteSpace}+=${exceptWhiteSpace}*`;
const queryParams = `${queryParamsPair}(&${queryParamsPair})*`;
const queryParamsDL = `(${queryParamsDLPair})+(&${queryParamsDLPair})*`;

// Pre-build regExp
export const tagPattern = `(\\{\\{\\s*${alphanumext}+\\s*\\}\\})`;
const urlPattern = `(https?://)(${baseUrl}|${ip})(:${port})?${resourceBlocks}(\\?${queryParams})?`;
const deepLinkPattern = `(${alphanumext}+://)(${alphanumext}+|${encodeUrl}+)([/|%]${alphanumext}*|${encodeUrl}*)*([?]*)(${queryParamsDL})*`;

/**
 * urlRule return a regular expression to check URL provided as : deeplink, tag name.
 * @returns {RegExp}
 */
export const urlRule = () => new RegExp(`^(${urlPattern}|${tagPattern})$`);

/**
 * emailRule return a regular expression to check email
 */
export const emailRule = () =>
  new RegExp('^\\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,3})+$');

/** `
 * deeplinkRule return a regular expression to check URL provided as : deeplink, tag name.
 * @returns {RegExp}
 */
export const deeplinkRule = () =>
  new RegExp(`^(${deepLinkPattern}|${tagPattern})$`);
/**
 * urlPatternRule return a regular expression to check URL provided as : web URL, deeplink, tag name.
 * @returns {RegExp}
 */
export const urlPatternRule = () =>
  new RegExp(`^(${deepLinkPattern}|${urlPattern}|${tagPattern})$`);
